import React, { useEffect, useState } from "react";
import { Alert, Row, Col, Form, Label, UncontrolledTooltip } from "reactstrap";

import { Navbar, Nav, Container, Offcanvas, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
// router
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

import logo from "../../assets/images/logo.webp";
import letterLogo from "../../assets/images/letter-logo.webp";
import topLogo from "../../assets/images/top-logo.webp";
import aboutUsSmallTopBg from "../../assets/images/aboutus-small-top-bg.webp";
import aboutUsLogo from "../../assets/images/aboutus-logo.webp";
import happyIcon from "../../assets/images/happyIcon.webp";
import star from "../../assets/images/star.webp";
import familyImage from "../../assets/images/familyImage.webp";
import globaleIcon from "../../assets/images/globalIcon.webp";
import aboutmeIcon from "../../assets/images/aboutmeIcon.webp";
import githubIcon from "../../assets/images/githubIcon.webp";
import linkedinIcon from "../../assets/images/linkedinIcon.webp";
import facebookIcon from "../../assets/images/facebookIcon.webp";
import LanguageSwitcher from "../../components/LanguageSelector";
import WomanIcon from "../../assets/images/woman-user.png";
import ManIcon from "../../assets/images/man-user.png";

const AboutUs = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const handleLogoClick = () => {
    navigate("/landing-page");
  };
  return (
    <div className="aboutUs-bg">
      <Navbar expand="lg" className="px-3 pt-3">
        <Container fluid>
          {/* Left: Logo */}
          <Navbar.Brand onClick={handleLogoClick} style={{ cursor: "pointer" }}>
            <img
              src={topLogo}
              alt="Logo"
              width="160"
              height="40"
              className="d-inline-block align-center"
            />
          </Navbar.Brand>
          <span className="d-flex gap-3">
            <span className="d-block d-lg-none">
              <LanguageSwitcher />
            </span>
            <Navbar.Toggle
              aria-controls="offcanvasNavbar-expand"
              style={{ fontSize: "1rem", padding: "5px 7px" }}
            />
            <Navbar.Offcanvas
              id="offcanvasNavbar-expand"
              aria-labelledby="offcanvasNavbarLabel-expand"
              placement="end" // Right side
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id="offcanvasNavbarLabel-expand">
                  {t("Menu")}
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                {/* Center-Right: Menu Items */}
                <Nav className="ms-auto me-3">
                  <Button
                    className="rounded-pill py-1 d-none d-lg-block"
                    style={{
                      backgroundColor: "#ede7e7",
                      color: "gray",
                      borderColor: "#ede7e7",
                      paddingRight: "40px",
                      paddingLeft: "40px",
                    }}
                    onClick={() =>
                      window.open(
                        "https://www.gofundme.com/f/heroinvoice-die-faire-erechnungslosung-fur-kleinunternehm",
                        "_blank",
                      )
                    }
                  >
                    {t("Donate")}
                  </Button>
                  <Nav.Link
                    as={Link}
                    to="/about-us"
                    className="top-menu-text-color"
                  >
                    {t("ABOUT US")}
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/learn-more"
                    className="top-menu-text-color"
                  >
                    {t("LEARN MORE")}
                  </Nav.Link>
                </Nav>

                {/* Right: Button */}

                <Button
                  className="rounded-pill py-1 d-block d-lg-none my-3 w-100"
                  style={{
                    backgroundColor: "#ede7e7",
                    color: "gray",
                    borderColor: "#ede7e7",
                    paddingRight: "40px",
                    paddingLeft: "40px",
                  }}
                  onClick={() =>
                    window.open(
                      "https://www.gofundme.com/f/heroinvoice-die-faire-erechnungslosung-fur-kleinunternehm",
                      "_blank",
                    )
                  }
                >
                  {t("Donate")}
                </Button>
                <Button
                  className="rounded-pill px-3 py-1 d-none d-lg-block"
                  style={{ backgroundColor: "#1e587e", borderColor: "white" }}
                  onClick={() => {
                    navigate("/auth-register");
                  }}
                >
                  {t("Try out for free")}
                </Button>

                {/* <LanguageSwitcher /> */}
                <Button
                  className="rounded-pill px-3 py-1 w-100 d-block d-lg-none"
                  style={{ backgroundColor: "#1e587e", borderColor: "white" }}
                  onClick={() => {
                    navigate("/auth-register");
                  }}
                >
                  {t("Try out for free")}
                </Button>
                <span className="d-none d-lg-block">
                  <LanguageSwitcher />
                </span>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </span>
        </Container>
      </Navbar>

      <div className="section wrapper1">
        <div className="w-half">
          <h1 className="main-title">{t("Who is the Team")}</h1>
          <div className="d-flex align-items-end">
            <h1 className="sub-main-title">{t("behind")}</h1>
            <img src={letterLogo} alt="Logo" className="letter-logo" />
            <h1 className="sub-main-question-symbol">?</h1>
          </div>
          <div className="aboutus-image-container">
            <div className="aboutus-text-overlay">
              <p className="sub-title text-center mt-4">
                {t("DIGITAL HEROES")}
              </p>
              <p className="sub-title text-center">
                {t("MORE THAN JUST A DEVELOPMENT TEAM.")}
              </p>
              <p style={{ fontWeight: "600" }} className="mt-3">
                {t(
                  "Digital Heroes is an interdisciplinary team of developers, designers, business experts and everyday strategists, united by the desire to develop products that not only look good, but also really work.",
                )}
              </p>
              <p style={{ fontWeight: "600" }}>
                {t(
                  "Hero-Invoice is our answer to overloaded tools and empty promises.",
                )}
              </p>
              <p style={{ fontWeight: "600" }}>
                {t("Lean. Understandable. Designed for real-life work.")}
              </p>
              <div
                className="d-flex justify-content-center"
                style={{ marginTop: "30px" }}
              ></div>
            </div>
          </div>
        </div>
        <div className="w-half">
          <img src={aboutUsSmallTopBg} className="top-bg img-responsive" />
        </div>
      </div>
      <div className="aboutus-section2" id="section2">
        <div className="d-flex wrapper2">
          <div className="w-40 d-flex justify-content-center">
            <img src={aboutUsLogo} className="aboutus-logo-img-responsive" />
          </div>
          <div className="aboutus-section2-text-container">
            <div>
              <h2 style={{ fontWeight: "800" }}>{t("Digital Heroes")} -</h2>
              <h2 style={{ fontWeight: "800" }}>
                {t("Expertise meets everyday practicality")}
              </h2>
              <div style={{ fontSize: "18px" }}>
                <p
                  style={{ color: "gray", fontWeight: "600" }}
                  className="mt-4"
                >
                  {t(
                    "Hero-Invoice is developed by an international team of real experts - each with special strengths in their own field. Whether UX design, security, programming, legal principles or financial accounting - we combine expertise from different areas and think together in terms of solutions.",
                  )}
                </p>
                <p style={{ color: "gray", fontWeight: "600" }}>
                  {t(
                    "What makes us special: although our team is globally networked, Hero-Invoice is managed locally. The project management team has first-hand knowledge of regional regulations, tax requirements and bureaucratic hurdles - and knows exactly what really matters when it comes to invoicing for small companies, start-ups or freelancers.we know what a good invoicing tool needs to do - and even better: what it doesn't need.",
                  )}
                </p>
                <p style={{ color: "gray", fontWeight: "600" }}>
                  {t("No unnecessary bells and whistles,")}
                </p>
                <p style={{ color: "gray", fontWeight: "600" }}>
                  {t("no hidden costs, no complicated processes.")}
                </p>
                <p style={{ color: "gray", fontWeight: "600" }}>
                  {t("Just a lean, reliable tool that simply works.")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="" id="section3">
        <div className="blue-bg">
          <div className="section5-main-title">
            {t("What our clients think about us...")}
          </div>
          <div className="section5-subtitle">
            {t(
              "A great isn't defined by its own words, but by the voices of those who've worked with it.",
            )}
          </div>
          <div className="aboutus-section5-container">
            <div className="box">
              <div className="top-center-icon">
                <img src={ManIcon} width="70" height="70" />
              </div>
              <div className="bottom-center-icon">
                <img src={star} />
              </div>
              <div className="section5-letter-box d-flex flex-column justify-content-between h-75">
                <h4 style={{ fontWeight: "700" }}>
                  {t("Reliable and well-organized team.")}
                </h4>
                <div className="box-letter">
                  <p style={{ color: "gray", fontWeight: "600" }}>
                    {t(
                      "The collaboration ran smoothly, agreements were adhered to, and queries were resolved promptly.",
                    )}
                  </p>
                  <p style={{ color: "gray", fontWeight: "600" }}>
                    {t("– Markus T., small business owner")}
                  </p>
                </div>
              </div>
            </div>
            <div className="box">
              <div className="top-center-icon">
                <img src={WomanIcon} width="70" height="70" />
              </div>
              <div className="bottom-center-icon">
                <img src={star} />
              </div>
              <div className="bottom-center-icon"></div>
              <div className="section5-letter-box d-flex flex-column justify-content-between h-75">
                <h4 style={{ fontWeight: "700" }}>
                  {t("Competent and solution-oriented.")}
                </h4>
                <div className="box-letter">
                  <p style={{ color: "gray", fontWeight: "600" }}>
                    {t(
                      "You can tell that the people at work here know their craft. Even detailed questions received quick, appropriate answers.",
                    )}
                  </p>
                  <p style={{ color: "gray", fontWeight: "600" }}>
                    {t("– Anne W., tax advisor")}
                  </p>
                </div>
              </div>
            </div>
            <div className="box">
              <div className="top-center-icon">
                <img src={ManIcon} width="70" height="70" />
              </div>
              <div className="bottom-center-icon">
                <img src={star} />
              </div>
              <div className="bottom-center-icon"></div>
              <div className="section5-letter-box d-flex flex-column justify-content-between h-75">
                <h4 style={{ fontWeight: "700" }}>
                  {t("Pleasant communication, clear processes.")}
                </h4>
                <div className="box-letter">
                  <p style={{ color: "gray", fontWeight: "600" }}>
                    {t(
                      "The team was easy to reach, friendly, and professional. I felt in good hands.",
                    )}
                  </p>
                  <p style={{ color: "gray", fontWeight: "600" }}>
                    {t("– Jens R., webshop operator")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section" id="section4">
        <div className="d-flex align-items-center wrapper2">
          <div className="w-60">
            <img src={familyImage} className="img-responsive" />
          </div>
          <div className="w-40 mt-4 px-2 mx-4">
            <p className="sub-title">
              {t("A STRONG TEAM ALWAYS HAS A STRONG NETWORK.")}
            </p>
            <h2 style={{ fontWeight: "800" }}>
              {t("Find us on Social Media")}
            </h2>

            <div
              style={{ color: "gray", fontWeight: "600", marginTop: "40px" }}
            >
              <p>
                {t(
                  "Want more insights, updates and business superpowers? Connect with us across our channels! Whether it’s LinkedIn, Facebook,GitHub or our official website – we’d love to meet you there.",
                )}
              </p>
            </div>
            <div className="aboutus-social-icons">
              <a
                href="https://www.facebook.com/people/Digital-Heroes/61573512770298/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={facebookIcon} className="social-icon" />
              </a>

              <a
                href="https://linkedin.com/in/yourprofile"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkedinIcon} className="social-icon" />
              </a>

              <a
                href="https://github.com/yourprofile"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={githubIcon} className="social-icon" />
              </a>

              <a
                href="https://www.gofundme.com/f/heroinvoice-die-faire-erechnungslosung-fur-kleinunternehm"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={aboutmeIcon} className="social-icon" />
              </a>

              <a
                href=" https://digitalheroes.vercel.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={globaleIcon} className="social-icon" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="footer-divider"></div>
        <Navbar expand="lg" className="px-3 pt-3">
          {/* Left: Logo */}
          <Navbar.Brand onClick={handleLogoClick} style={{ cursor: "pointer" }}>
            <img
              src={topLogo}
              alt="Logo"
              width="160"
              height="40"
              className="d-inline-block align-center"
            />
          </Navbar.Brand>

          {/* Center-Right: Menu Items */}
          <Nav className="ms-auto me-3">
            <Nav.Link as={Link} to="/imprint" className="text-gray">
              {t("Imprint")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/terms" className="text-gray">
              {t("Terms of Use")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/privacy" className="text-gray">
              {t("Privacy Policy")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/contact-us" className="text-gray">
              {t("Contact")}
            </Nav.Link>
          </Nav>
        </Navbar>
      </div>
    </div>
  );
};

export default AboutUs;
